module.exports = new __parcel__URL__("lock.143fbe09.svg").toString();